export default __webpack_public_path__ + "static/media/workspace_icon_white.76e0d486.svg";